import * as React from 'react';
import { RouteProps } from 'react-router';
import { inject, observer } from 'mobx-react';
import { Redirect, Route, RouteComponentProps } from 'react-router-dom';
import { AUTH_STORE } from '../constants/constants';

@inject(AUTH_STORE)
@observer
class PrivateRoute extends React.Component<RouteProps> {
  constructor(props: RouteProps) {
    super(props);
  }

  render() {
    const isLoggedIn = this.props[AUTH_STORE].isLoggedIn;

    return (
      isLoggedIn ? (
        <Route {...this.props}/>
      ) : (
        <Redirect to="/" />
      )
    );
  }
}

export default PrivateRoute;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PrivateRoute.tsx